<lib-dlg titulo="Troca de item da Requisição" nome="dlgTrocaRequisicao" [visualizar]="visualizar" (onHide)="onHide()"
  styleClassHeader="text-white bg-secondary">
  <div *ngIf="item" class="row">
    <div class="col-sm-12">
      <div class="form-row">
        <div class="col-sm-12 form-group">
          <label for="produto_unidade">Produto Unidade</label>
          <p-autoComplete id="rec" [(ngModel)]="itemAlteracao.produto_unidade.produto" [forceSelection]="true"
            [autoHighlight]="true" [ngModelOptions]="{standalone: true}" [field]="produtoAutoComplete.conversor"
            [suggestions]="produtoAutoComplete.lista" (completeMethod)="produtoAutoComplete.filtrar($event)"
            (onSelect)="carregarUnidades()" inputStyleClass="form-control form-control-sm" minLength="2"
            [style]="{ width: '75%' }">
            <ng-template let-produto pTemplate="item">
              {{produto.codigo}} {{produto.nome}}
            </ng-template>
          </p-autoComplete>
          <select [compareWith]="compareFn" id="produto_unidade" [(ngModel)]="itemAlteracao.produto_unidade"
            [ngModelOptions]="{standalone: true}" class="form-control form-control-sm float-right" style="width: 25%;"
            (change)="carregarLotes()">
            <option [ngValue]="undefined">---</option>
            <option [ngValue]="itemP" *ngFor="let itemP of listProdUn">
              {{itemP.unidade.nome}}
            </option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-8 form-group">
          <label for="lote">Lote Vencimento</label>
          <p-autoComplete styleClass="form-control form-control-sm p-0" [forceSelection]="true"
          [autoHighlight]="true" [inputStyle]="{'font-size' : '12px'}" [ngModel]="{lote : itemAlteracao.lote, vencimento : itemAlteracao.vencimento}"
          (ngModelChange)="onChangeLote($event)" [suggestions]="listLoteVecFiltro" [style]="{ width: '100%' }"
          (completeMethod)="buscarLoteVencimento($event)" [field]="conversorLote" [dropdown]="true">
            <ng-template let-itemL pTemplate="item">
              <div class="d-flex jutify-content-between align-item-center" style="font-size: 12px;">
                <div class="d-flex flex-column justify-content-center align-item-start">
                  <span><b>LOTE:</b> {{itemL.lote}}</span>
                  <span><b>VENCIMENTO:</b> {{itemL.vencimento | date : 'dd/MM/yyyy' : 'GMT'}}</span>
                </div>
                <div class="d-flex flex-column justify-content-center align-item-end ml-2">
                  <span><b>SALDO {{requisicao.devolucao ? 'DEVOLUÇÂO' : ''}}:</b></span>
                  <span>{{(requisicao.devolucao ? itemL.saida : itemL.saldo_atual) | number:'1.5-5'}}</span>
                </div>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
        <div class="col-sm-4 form-group d-flex fo justify-content-end align-items-end">
          <span class="text-primary" style="font-size: 15px;"><b>Saldo: {{itemAlteracao.saldo_atual | number:'1.5-5'}}</b></span>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-12 form-group">
          <label for="obs">Justificativa de Troca</label>
          <textarea [(ngModel)]="itemAlteracao.justificativa_troca" class="form-control" id="obs" rows="3"></textarea>
        </div>
      </div>
    </div>
  </div>
  <ng-container opcoes>
    <button (click)="salvar()" type="submit" class="btn btn-danger btn-sm float-right ml-2">Confirmar</button>
  </ng-container>
</lib-dlg>